import React from 'react';
import { Image } from '../components';
import PropTypes from 'prop-types';
import mdToHtml from '../utils/mdToHtml';
import { media } from '../utils/media';

const SectionHighlight = ({content})=> {
  if(!content.enabled) return false;
  return (
     <div className='aligners-wrapper'>
      <div className='section-text'>
        <h2 className='mb-40' dangerouslySetInnerHTML={{ __html: content.title }} />
        <div dangerouslySetInnerHTML={{ __html: mdToHtml(content.text) }} />
      </div>
      <Image url={media(content.image)} alt={content.title} className='section-media' />
    </div>
  );
}

SectionHighlight.propTypes = {
  content: PropTypes.object.isRequired,
};

SectionHighlight.defaultProps = {
  content: {}
};

export default SectionHighlight;